var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.035 8.47C20.823 3.237 17.481 0 17.481 0s-3.317 3.237-8.53 8.47C6.213 11.221 0 18.063 0 24.868c0 4.541 3.678 8.227 8.194 8.227a8.146 8.146 0 006.989-3.96c.149-.181.391-.331.633-.331.423 0 .814.3.752.667-.304 2.452-1.69 8.47-7.113 10.529h15.972c-5.424-2.027-6.778-8.077-7.113-10.529-.062-.361.329-.667.751-.667.274 0 .51.15.634.33 1.416 2.358 4.038 3.961 6.989 3.961 4.522 0 8.194-3.692 8.194-8.227.105-6.805-6.1-13.64-8.846-16.398z",
    fill: "#D70A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.512 8.47l2.2 6.868h7.2l-5.815 4.235 2.23 6.867-5.815-4.235-5.814 4.235 2.199-6.867-5.815-4.235h7.2l2.23-6.868z",
    fill: "#fff"
  })));
}

SvgPsLogo.displayName = 'PsLogo';
export default SvgPsLogo;